
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {
SaafHeader,
SaafFooter,
} from '@/common/components/index'
import { mapState } from 'vuex'

import { fetchTool } from '@/common/index'
import api from './config/api'
import {fetch} from '../index'


export default {
data () {
return {
fileList:[]
}
},
components: {
SaafHeader,
SaafFooter,
XButton,
XInput,
Group,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
}),
},
created(){

},
methods: {
fetchPost(){
fetch.baseLookupTypeService_find({
params:{  // 参数无需转JSON
p1:1,
p2:2
},
pageIndex:1,
pageRow:10
}).then(res=>{
alert('请求成功')
}).catch(err=>{
alert('请求失败')
})
},
postSimpleness(){
fetchTool.postSimpleness(api.baseLookupTypeService_find,{
params:{  // 参数无需转JSON
p1:1,
p2:2
},
pageIndex:1,
pageRow:10
}).then(res=>{
alert('请求成功')
}).catch(err=>{
alert('请求失败')
})
},
post(){
fetchTool.post(api.baseLookupTypeService_find,{
params:{  // 参数无需转JSON
p1:1,
p2:2
},
pageIndex:1,
pageRow:10
}).then(res=>{
alert('请求成功')
}).catch(err=>{
alert('请求失败')
})
},
postV1(){
fetchTool.post(api.saleBrcCodedataService_findMtlSystemItemsPagination,{
params:{
itemCode: '11202001',
a:{a1:1,a2:2,c:{a:1}}
}
}).then(res=>{
alert('请求成功')
}).catch(err=>{
alert('请求失败')
})
},
postAlert(){
fetchTool.postAlert(api.baseLookupTypeService_find,{
params:{  // 参数无需转JSON
p1:1,
p2:2
},
pageIndex:1,
pageRow:10
}).then(res=>{
alert('请求成功')
}).catch(err=>{
alert('请求失败')
})
},
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/Post.vue